import { useWorld } from './use-world'
export const useCollision = () => {
  const { container, offset, sprites } = useWorld()
  const isInViewport = (obj) => {
    return (
      obj.y >= 0 &&
      obj.x >= 0 &&
      obj.x + obj.width <= container.width &&
      obj.y + obj.height <= container.height
    )
  }

  const isColliding = (obj) => {
    const objects = Object.keys(sprites)
    let collision = false
    objects.forEach((key) => {
      if (collision) return collision
      if (obj.id === key) {
        collision = !isInViewport(obj) ? obj : false
      } else if (
        doObjectsCollide(obj, sprites[key].position) ||
        !isInViewport(obj)
      ) {
        collision = sprites[key]
      }
    })
    return collision
  }

  const isInteracting = (obj) => {
    const objects = Object.keys(sprites)
    const collisions = []
    objects.forEach((key) => {
      const sprite = sprites[key]
      if (obj.id === key || !sprite?.position?.config.npc) {
        return null
      } else if (doObjectsCollide(obj, sprite.position)) {
        collisions.push(sprite)
      }
    })
    return collisions
  }

  const doObjectsCollide = (box1, box2) => {
    if (!box1 || !box2) return false
    return (
      box1.x < box2.x + box2.width &&
      box1.x + box1.width > box2.x &&
      box1.y < box2.y + box2.height &&
      box1.y + box1.height > box2.y
    )
  }

  return { isColliding, isInteracting }
}
